export class AuthorizeNetProfileParamsDto {
  constructor(data) {
    this.group_admin_id = data.group_admin_id;
  }
}
